import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { context: String }

  connect() {
    document.addEventListener("turbo:fetch-request-error", this.handleTurboError.bind(this))
    this.setupScopedErrorHandler()
  }

  disconnect() {
    if (this.turboErrorHandler) {
       document.removeEventListener("turbo:fetch-request-error", this.turboErrorHandler)
       this.turboErrorHandler = null
    }
    window.onerror = this.oldOnError
    window.onunhandledrejection = this.oldOnUnhandledRejection
  }

  setupScopedErrorHandler() {
    this.oldOnError = window.onerror
    this.oldOnUnhandledRejection = window.onunhandledrejection

    window.onerror = (message, url, line, col, error) => {
      this.reportError({ 
        message: message, 
        context: `${this.contextValue} (JS Error)`,
        url: url, 
        line: line 
      })
      if (typeof this.oldOnError === "function") return this.oldOnError(message, url, line, col, error)
    }

    window.onunhandledrejection = (event) => {
      const msg = event.reason?.message || "Promise Rejection"
      if (msg.includes("Failed to fetch")) return

      this.reportError({ message: msg, context: `${this.contextValue} (Promise Error)` })
      if (typeof this.oldOnUnhandledRejection === "function") return this.oldOnUnhandledRejection(event)
    }
  }

  async handleTurboError(event) {
    const { response, request } = event.detail.fetchResponse
    if (request.url.includes('/catch_errors') || !response || response.status === 0) return

    event.stopPropagation()
    let responseBody = ""
    try { 
      responseBody = (await response.clone().text()).substring(0, 500) 
    } catch (e) { 
      responseBody = "Body ilegível" 
    }

    this.reportError({
      message: `Turbo Error: ${response.status}`,
      path: request.url,
      verb: request.method,
      status: response.status,
      context: this.contextValue,
      response: responseBody
    })
  }

  reportError(payload) {
    if (!navigator.onLine) return

    const data = {
      ...payload,
      url: payload.url || window.location.href,
      line: payload.line || `Monitor:${this.contextValue}`
    }

    fetch('/catch_errors', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify(data),
      keepalive: true
    }).catch(() => {
      // Prevent infinite loops
    })
  }
}
